import request from '../utils/http'
// 设置
export function from (query) {
  return request({
    url: '/setting/getInfo',
    method: 'POST',
    data: query
  })
}
// 首页设置
export function setIndex (query) {
  return request({
    url: '/setting/setIndex',
    method: 'POST',
    data: query
  })
}
// 首页设置2
export function setIndexV2 (query) {
  return request({
    url: '/setting/setIndexV2',
    method: 'POST',
    data: query
  })
}
// 个人设置
export function setPersonal (query) {
  return request({
    url: '/setting/setPersonal',
    method: 'POST',
    data: query
  })
}
// 个人设置2
export function setPersonalV2 (query) {
  return request({
    url: '/setting/setPersonalV2',
    method: 'POST',
    data: query
  })
}
// 闯关设置
export function setThrough (query) {
  return request({
    url: '/setting/setThrough',
    method: 'POST',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/setting.js